// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.records-preview-block {
  margin-bottom: 8px;
}

.records-preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.records-preview-head .section-title {
  margin-bottom: 13px;
}

.records-preview-all {
  color: #232137;
  text-decoration: none;
  font-size: 0.98rem;
  font-weight: 700;
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 0 3px 12px rgba(36, 41, 57, 0.06);
  transition: color 0.15s ease, background 0.15s ease;
}

.records-preview-all:hover {
  color: #e72f44;
  background: #fff3f5;
}

.records-preview-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.records-preview-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.records-preview-subheader {
  margin: 0 8px;
  padding: 9px 14px 8px;
  border-radius: 16px 16px 0 0;
  background: linear-gradient(90deg, #232137 0%, #3c2f62 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.94rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.records-preview-card {
  margin-bottom: 0;
  padding: 16px 14px;
}

.records-preview-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.records-preview-client {
  font-size: 1.03rem;
  font-weight: 700;
  color: #232137;
  margin-bottom: 6px;
}

.records-preview-services {
  font-size: 0.95rem;
  color: #232137;
  line-height: 1.4;
  margin-bottom: 8px;
}

.records-preview-meta {
  font-size: 0.9rem;
  color: #7a7f90;
}

.records-preview-side {
  min-width: 88px;
  text-align: right;
}

.records-preview-amount {
  font-size: 0.98rem;
  font-weight: 800;
  color: #232137;
}

.records-preview-badges {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.records-preview-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eef6ff;
  color: #2d74da;
  font-size: 0.78rem;
  font-weight: 700;
}

.records-preview-badge.confirmed {
  background: #eaf8ed;
  color: #1c8341;
}

.records-preview-state {
  color: #7d8ca6;
  font-size: 0.97rem;
  line-height: 1.45;
}

.records-preview-state.error {
  color: #b51d31;
  background: #fff0f2;
}

@media (max-width: 420px) {
  .records-preview-subheader {
    margin: 0 4px;
    padding: 8px 12px 7px;
  }
  .records-preview-row {
    flex-direction: column;
    gap: 10px;
  }
  .records-preview-side {
    min-width: auto;
    text-align: left;
  }
  .records-preview-badges {
    justify-content: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/block/RecordsPreview/recordsPreview.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qCAAA;EACA,6CAAA;EACA,mDAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,4BAAA;EACA,4DAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,aAAA;IACA,qBAAA;EACF;EAEA;IACE,sBAAA;IACA,SAAA;EAAF;EAGA;IACE,eAAA;IACA,gBAAA;EADF;EAIA;IACE,2BAAA;EAFF;AACF","sourcesContent":[".records-preview-block {\n  margin-bottom: 8px;\n}\n\n.records-preview-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.records-preview-head .section-title {\n  margin-bottom: 13px;\n}\n\n.records-preview-all {\n  color: #232137;\n  text-decoration: none;\n  font-size: 0.98rem;\n  font-weight: 700;\n  padding: 10px 14px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.75);\n  box-shadow: 0 3px 12px rgba(36, 41, 57, 0.06);\n  transition: color 0.15s ease, background 0.15s ease;\n}\n\n.records-preview-all:hover {\n  color: #e72f44;\n  background: #fff3f5;\n}\n\n.records-preview-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.records-preview-link {\n  text-decoration: none;\n  color: inherit;\n  display: block;\n}\n\n.records-preview-subheader {\n  margin: 0 8px;\n  padding: 9px 14px 8px;\n  border-radius: 16px 16px 0 0;\n  background: linear-gradient(90deg, #232137 0%, #3c2f62 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 0.94rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n}\n\n.records-preview-card {\n  margin-bottom: 0;\n  padding: 16px 14px;\n}\n\n.records-preview-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.records-preview-client {\n  font-size: 1.03rem;\n  font-weight: 700;\n  color: #232137;\n  margin-bottom: 6px;\n}\n\n.records-preview-services {\n  font-size: 0.95rem;\n  color: #232137;\n  line-height: 1.4;\n  margin-bottom: 8px;\n}\n\n.records-preview-meta {\n  font-size: 0.9rem;\n  color: #7a7f90;\n}\n\n.records-preview-side {\n  min-width: 88px;\n  text-align: right;\n}\n\n.records-preview-amount {\n  font-size: 0.98rem;\n  font-weight: 800;\n  color: #232137;\n}\n\n.records-preview-badges {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.records-preview-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 24px;\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: #eef6ff;\n  color: #2d74da;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.records-preview-badge.confirmed {\n  background: #eaf8ed;\n  color: #1c8341;\n}\n\n.records-preview-state {\n  color: #7d8ca6;\n  font-size: 0.97rem;\n  line-height: 1.45;\n}\n\n.records-preview-state.error {\n  color: #b51d31;\n  background: #fff0f2;\n}\n\n@media (max-width: 420px) {\n  .records-preview-subheader {\n    margin: 0 4px;\n    padding: 8px 12px 7px;\n  }\n\n  .records-preview-row {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .records-preview-side {\n    min-width: auto;\n    text-align: left;\n  }\n\n  .records-preview-badges {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
